import { CmtsAuditLogGrid } from "@components/audit/index.js";
import type { ComponentDiagnostic } from "@swot/base-components";

type Row = Record<string, unknown>;

export type AuditExportFormat = "CSV" | "XLS" | "JSON";

export type CmtsAuditLogsPageProps = {
  readonly pageTitle?: string | undefined;
  readonly events?: readonly Row[] | undefined;
  readonly exportHistory?: readonly Row[] | undefined;
  readonly diagnostics?: readonly ComponentDiagnostic[] | undefined;
  readonly loading?: boolean | undefined;
  readonly error?: string | null | undefined;
  readonly onOpenEvent?:
    | ((event: Row) => void | Promise<Row | void>)
    | undefined;
  readonly onExportAudit?:
    | ((
        events: readonly Row[],
        format: AuditExportFormat,
      ) => void | Promise<void>)
    | undefined;
  readonly onOpenLinkedRecord?:
    | ((event: Row) => void | Promise<void>)
    | undefined;
};

export function CmtsAuditLogsPage(props: CmtsAuditLogsPageProps) {
  return (
    <CmtsAuditLogGrid
      pageTitle={props.pageTitle ?? "Audit Logs"}
      rows={props.events ?? []}
      exportHistory={props.exportHistory ?? []}
      loading={Boolean(props.loading)}
      error={props.error ?? null}
      {...(props.onOpenEvent
        ? { onOpenEvent: props.onOpenEvent }
        : {})}
      {...(props.onExportAudit
        ? { onExportAudit: props.onExportAudit }
        : {})}
      {...(props.onOpenLinkedRecord
        ? { onOpenLinkedRecord: props.onOpenLinkedRecord }
        : {})}
    />
  );
}